import { tokenizedAxios } from './axiosInterceptor';
import { customAxios, tokenizedRequest } from './customAxios';
import { generatePhpAuthParams } from './helperServices';

export const makePayment = async paymentData => {
  const url = `${process.env.REACT_APP_API_URL}/billing/invoices/pay/v2`;
  try {
    const response = await tokenizedAxios.post(url, paymentData);

    const { _success, _data } = response.data;

    const allTransactionsSuccessful = _data?.allTransactionsSuccessful ?? false;

    return {
      success: _success,
      allTransactionsSuccessful,
    };
  } catch (error) {

    return {
      success: false,
      allTransactionsSuccessful: false,
      sessionExpired: !!error.isSessionExpired,
    };
  }
};

export const updatePrimaryMethod = async (data, subscriptionId) => {
  const url = `${process.env.REACT_APP_API_URL}/billing/subscriptions/${subscriptionId}`;
  let requestObj = { method: 'PATCH', url, data };
  let response = await tokenizedRequest(requestObj);
  if (
    !response ||
    !response.billingMethods ||
    !response.billingMethods.length
  ) {
    return { success: false, sessionExpired: !!response?.reason?.isSessionExpired };
  }
  return { success: true };
};

export const createBillingMethod = async data => {
  const url = `${process.env.REACT_APP_API_URL}/billing/methods`;
  let requestObj = { method: 'POST', url, data };
  let response = await tokenizedRequest(requestObj);
  if (!response || !response.id) {
    return { success: false, sessionExpired: !!response?.reason?.isSessionExpired };
  }
  return { success: true, id: response.id };
};

export const activateServices = async locationObj => {
  const url = `${process.env.REACT_APP_PHP_API_URL}/updateNetworkData`;
  const jwtHeaders = generatePhpAuthParams();

  const formData = new FormData();
  formData.append('mobileOrdering', '1');
  formData.append('ntwkid', locationObj.locationId);

  if (locationObj?.crmDealIds?.length) {
    formData.append('crmDealIds', JSON.stringify(locationObj.crmDealIds));
  }

  const requestObj = {
    method: 'POST',
    url,
    data: formData,
    headers: { ...jwtHeaders },
  };

  await customAxios(requestObj);
};

export const getStateByZip = async zip => {
  let params = {};
  params.zip = zip;
  const url = `https://www.gonogosupport.com/gonogoApi1909Secure/index.php/api/getZipCodeInfo/`;
  let requestObj = { method: 'POST', url, params };
  let response = await customAxios(requestObj);
  if (!response.msg === 'success' || !response.desc || !response.desc.City) {
    return { error: true, msg: 'Please enter a valid zip code.' };
  }
  let result = response.desc;
  const city = result.City;
  const state = result.StateAbb;
  result = { success: true, city, state };
  return result;
};
